import { isDev } from '@/utils/helpers';

const PlaygroundPage = () => import('@/playground/pages/playground.vue');

export const playgroundRoutes =
  isDev || import.meta.env.VITE_ENVIRONMENT !== 'production'
    ? [{ path: '/playground/:page?', name: 'playground', component: PlaygroundPage }]
    : [];
